(() => {
  const finder = document.querySelector('[data-acyros-tool-finder]');
  if (!finder || finder.dataset.ready) return;
  finder.dataset.ready = 'true';

  const questions = Array.from(finder.querySelectorAll('[data-finder-step]'));
  const progress = Array.from(finder.querySelectorAll('.acy-v19-finder__progress span'));
  const result = finder.querySelector('.acy-v19-finder__result');
  const title = finder.querySelector('[data-finder-title]');
  const copy = finder.querySelector('[data-finder-copy]');
  const link = finder.querySelector('[data-finder-link]');
  const restart = finder.querySelector('[data-finder-restart]');
  const answers = [];
  const products = {
    roller: {
      title: 'Der ACYROS Gesichtsroller',
      copy: 'Ein kurzer, kühler Schritt für deinen Morgen. Klar, unkompliziert und leicht zu reinigen.',
      href: '/products/acryos-gesichtsroller-316l-chirurgenstahl'
    },
    gua: {
      title: 'Die ACYROS Gua Sha',
      copy: 'Für präzise Züge an Kiefer, Wangen und Hals – als gezielter Schritt in deiner Routine.',
      href: '/products/acryos-gua-sha-316l-chirurgenstahl'
    },
    set: {
      title: 'Das ACYROS Ritual Set',
      copy: 'Zwei aufeinander abgestimmte Edelstahl-Tools für ein vollständiges, ruhiges Ritual.',
      href: '/products/acryos-das-ritual-set-gesichtsroller-gua-sha'
    }
  };

  const show = (index) => {
    questions.forEach((question, i) => {
      const active = i === index;
      question.hidden = !active;
      question.classList.toggle('is-active', active);
    });
    progress.forEach((dot, i) => dot.classList.toggle('is-active', i <= index));
  };

  finder.querySelectorAll('[data-choice]').forEach((button) => {
    button.addEventListener('click', () => {
      const step = Number(button.closest('[data-finder-step]').dataset.finderStep);
      answers[step] = button.dataset.choice;
      if (step < questions.length - 1) {
        show(step + 1);
        return;
      }
      const primary = answers[0];
      const finish = answers[2];
      const key = finish === 'complete' || primary === 'set' ? 'set' : finish === 'focused' || primary === 'gua' ? 'gua' : 'roller';
      const product = products[key];
      title.textContent = product.title;
      copy.textContent = product.copy;
      link.href = product.href;
      questions.forEach((question) => { question.hidden = true; question.classList.remove('is-active'); });
      result.hidden = false;
      result.classList.add('is-active');
      progress.forEach((dot) => dot.classList.add('is-active'));
    });
  });

  restart.addEventListener('click', () => {
    answers.length = 0;
    result.hidden = true;
    result.classList.remove('is-active');
    show(0);
  });
})();
